import React from "react";
import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://kochefcatering.com";
const DEFAULT_IMG = SITE_URL + "/logo-official.png";

export const Seo = ({ title, description, path = "", image, jsonLd, noindex = false }) => {
  const url = SITE_URL + path;
  const img = image || DEFAULT_IMG;
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export default Seo;
